import styled from "styled-components";
import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text as BBText } from "@acko-tech/building-blocks.ui.typography";

export const ContentWrapper = styled.div<{ isDesktop?: boolean }>`
  padding: ${(p) => (p.isDesktop ? "24px" : "16px 20px 24px 20px")};
`;

export const TopImageWrapper = styled.div`
  width: 100%;
  margin-top: -26px;
  margin-bottom: 0;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    display: block;
  }
`;

export const Title = styled.div`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.1px;
  margin-bottom: 24px;
`;

export const SectionTitle = styled.div`
  color: var(--Text-Primary-grey600, #121212);
  font-family: "Euclid Circular B";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  align-self: stretch;
  margin-bottom: 12px;
`;

export const Text = styled(BBText)`
  font-size: 14px;
  line-height: 20px;
  color: #36354c;
`;

export const CardRow = styled(Flex)`
  gap: 12px;
  overflow-x: auto;
  margin-top: 8px;
`;

export const Card = styled(Box)`
  min-width: 240px;
  border: 1px solid #e7e7f0;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const CardText = styled.div`
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-weight: 500;
  color: #121212;

  span {
    display: block;
    font-size: 12px;
    color: #5b5675;
    margin-top: 4px;
  }
`;

export const DotsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  margin: 12px 0;
`;

export const Dot = styled.div<{ active?: boolean }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${(p) => (p.active ? "#121212" : "#d9d9e3")};
`;

export const PrimaryButton = styled.button`
  width: 100%;
  margin-top: 8px;
  padding: 14px;
  border-radius: 12px;
  border: none;
  background: #121212;
  color: #ffffff;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;

export const FeatureItem = styled.div`
  display: block;
  margin-bottom: 12px;
  flex: 1 0 0;
`;

export const FeatureTitle = styled.span`
  color: #000;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
`;

export const FeatureDescription = styled.span`
  color: #000;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const FeatureList = styled.div`
  margin-bottom: 24px;
`;
